module.exports = __webpack_public_path__ + "img/microsoft.2d00d086.svg";